/**
 * Represents the methods by which a [[Member]] can be contacted.
 */
export var MemberContactMethod;
(function (MemberContactMethod) {
    /**
     * SMS
     */
    MemberContactMethod["Sms"] = "Sms";
    /**
     * Email
     */
    MemberContactMethod["Email"] = "Email";
    /**
     * Mail
     */
    MemberContactMethod["Mail"] = "Mail";
    /**
     * Phone
     */
    MemberContactMethod["Phone"] = "Phone";
    /**
     * Fax
     */
    MemberContactMethod["Fax"] = "Fax";
})(MemberContactMethod || (MemberContactMethod = {}));
//# sourceMappingURL=member-contact-method.js.map